import { Paper, Divider } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "material-ui-flat-pagination";
import React, { useState } from "react";
import { useGetArticlesV1 } from "../../../hooks/api";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles(theme => ({
  root: {
    margin: "auto",
    width: "100%",
    maxWidth: 500,
    padding: theme.spacing(1)
  },
  pagination: {
    textAlign: "center"
  }
}));

const ArticleSkeleton = (): JSX.Element => {
  const item = (
    <div style={{ padding: 10 }}>
      <Skeleton height={30} width="20%" />
      <Skeleton height={20} width="90%" />
      <Skeleton height={20} width="90%" />
      <Divider />
    </div>
  );
  return (
    <>
      {item}
      {item}
      {item}
    </>
  );
};

const numPerPage = 6;

export default function ArticleList(): JSX.Element {
  const classes = useStyles();
  const [offset, setOffset] = useState<number>(0);
  const { data: res } = useGetArticlesV1({
    queryParams: {
      offset: 0
    }
  });

  return (
    <Paper className={classes.root}>
      <List
        subheader={
          <ListSubheader component="span" disableSticky>
            文章
          </ListSubheader>
        }
      >
        {res?.data.map(item => (
          <ListItem button divider key={item.id}>
            <ListItemText
              primary={item.title}
              primaryTypographyProps={{ color: "textPrimary" }}
              secondary={item.content}
              secondaryTypographyProps={{ color: "textSecondary" }}
            />
          </ListItem>
        ))}
        {!res && <ArticleSkeleton />}
      </List>
      <div className={classes.pagination}>
        <Pagination
          limit={numPerPage}
          offset={offset}
          total={100}
          onClick={(e, newOffset): void => setOffset(newOffset)}
        />
      </div>
    </Paper>
  );
}
